import React from 'react';
import { Dices } from 'lucide-react';

/**
 * Component for selecting stat generation mode
 */
const StatModeSelector = ({ statMode, setStatMode }) => {
  return (
    <div className="bg-white p-6 mb-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4 flex items-center">
        <Dices className="mr-2" />
        Ability Score Generation
      </h2>
      
      <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
        <button
          onClick={() => setStatMode('normal')}
          className={`px-4 py-2 rounded ${
            statMode === 'normal' ? 'bg-green-600 text-white' : 'bg-gray-200'
          }`}
        >
          Normal (4d6kh3)
        </button>
        
        <button
          onClick={() => setStatMode('hardcore')}
          className={`px-4 py-2 rounded ${
            statMode === 'hardcore' ? 'bg-yellow-600 text-white' : 'bg-gray-200'
          }`}
        >
          Hardcore (3d6)
        </button>
        
        <button
          onClick={() => setStatMode('nightmare')}
          className={`px-4 py-2 rounded ${
            statMode === 'nightmare' ? 'bg-red-600 text-white' : 'bg-gray-200'
          }`}
        >
          Nightmare (4d6kl3)
        </button>
      </div>
    </div>
  );
};

export default StatModeSelector;
